import type { Locale } from "./domain";

const messages = {
  ar: {
    accept: "قبول الطلب",
    activateAlerts: "تفعيل صوت التنبيهات",
    addItem: "إضافة صنف",
    allCaughtUp: "لا توجد طلبات جديدة",
    available: "متوفر",
    balance: "الرصيد المستحق",
    cancel: "إلغاء",
    catalogEmpty: "لا توجد قائمة بعد",
    catalogEmptyHint: "ابدأ بإنشاء فئة ثم أضف الأصناف إليها. لن يرى الزبائن شيئًا قبل النشر.",
    charged: "المحمّل فعليًا",
    confirmDelete: "تأكيد الحذف",
    conflict: "تغيّرت هذه البيانات على جهاز آخر. حدّثنا النسخة ولم ننفّذ الأمر القديم.",
    connectionLive: "متصل لحظيًا",
    connectionOffline: "دون اتصال",
    connectionSync: "تجري المزامنة",
    deleteLabel: "حذف",
    discardChanges: "تجاهل التعديلات",
    discardCommand: "حذف الأمر القديم",
    draftSaved: "حُفظت المسودة وستُزامن مع الخادم",
    editLabel: "تعديل",
    feeBase: "الرسم الأساسي",
    feeWaiver: "الإعفاء",
    finance: "المالية",
    login: "دخول الشريك",
    menu: "القائمة",
    modifiedInDraft: "معدّل",
    modifierGroups: "مجموعات الخيارات",
    moveDown: "نقل للأسفل",
    moveUp: "نقل للأعلى",
    newCategory: "فئة جديدة",
    newGroup: "مجموعة خيارات جديدة",
    newInDraft: "جديد",
    newItem: "صنف جديد",
    newOrders: "طلبات جديدة",
    next: "متابعة",
    offlineCopy: "نعرض آخر نسخة محفوظة. الأوامر ستبقى معلّقة حتى عودة الشبكة.",
    orders: "الطلبات",
    otp: "رمز التحقق",
    phone: "رقم الهاتف",
    prep: "وقت التحضير",
    preparing: "قيد التحضير",
    publishChanges: "نشر التغييرات",
    publishConfirm: "تأكيد النشر",
    publishQueued: "أُرسل أمر النشر وسيُنفَّذ عند المزامنة",
    publishSummary: "ملخص النشر",
    ready: "جاهز للتسليم",
    reject: "رفض بسبب",
    rename: "إعادة تسمية",
    save: "حفظ",
    saveDraft: "حفظ المسودة",
    saveFirst: "احفظ المسودة أولًا",
    signOut: "خروج",
    startPrep: "بدء التحضير",
    storeClosed: "استقبال الطلبات متوقف",
    storeOpen: "يستقبل الطلبات",
    syncIssue: "أمر يحتاج مراجعة",
    unavailable: "غير متوفر",
    unsavedChanges: "تغييرات غير محفوظة",
    waitingSync: "بانتظار المزامنة",
  },
  fr: {
    accept: "Accepter",
    activateAlerts: "Activer le son des alertes",
    addItem: "Ajouter un article",
    allCaughtUp: "Aucune nouvelle commande",
    available: "Disponible",
    balance: "Solde à verser",
    cancel: "Annuler",
    catalogEmpty: "Aucune carte pour le moment",
    catalogEmptyHint:
      "Créez une catégorie puis ajoutez des articles. Rien n’est visible avant publication.",
    charged: "Frais facturés",
    confirmDelete: "Confirmer la suppression",
    conflict: "Ces données ont changé sur un autre appareil. La version actuelle a été rechargée.",
    connectionLive: "Direct connecté",
    connectionOffline: "Hors ligne",
    connectionSync: "Synchronisation",
    deleteLabel: "Supprimer",
    discardChanges: "Annuler les modifications",
    discardCommand: "Supprimer l’action obsolète",
    draftSaved: "Brouillon enregistré, synchronisation en cours",
    editLabel: "Modifier",
    feeBase: "Frais de base",
    feeWaiver: "Exonération",
    finance: "Finances",
    login: "Connexion partenaire",
    menu: "Carte",
    modifiedInDraft: "Modifié",
    modifierGroups: "Groupes d’options",
    moveDown: "Descendre",
    moveUp: "Monter",
    newCategory: "Nouvelle catégorie",
    newGroup: "Nouveau groupe d’options",
    newInDraft: "Nouveau",
    newItem: "Nouvel article",
    newOrders: "Nouvelles commandes",
    next: "Continuer",
    offlineCopy: "Dernière copie enregistrée. Les actions resteront en attente du réseau.",
    orders: "Commandes",
    otp: "Code de vérification",
    phone: "Numéro de téléphone",
    prep: "Temps de préparation",
    preparing: "En préparation",
    publishChanges: "Publier les changements",
    publishConfirm: "Confirmer la publication",
    publishQueued: "Publication envoyée, elle sera appliquée à la synchronisation",
    publishSummary: "Résumé de publication",
    ready: "Prête à remettre",
    reject: "Refuser pour",
    rename: "Renommer",
    save: "Enregistrer",
    saveDraft: "Enregistrer le brouillon",
    saveFirst: "Enregistrez d’abord le brouillon",
    signOut: "Sortir",
    startPrep: "Lancer la préparation",
    storeClosed: "Commandes suspendues",
    storeOpen: "Accepte les commandes",
    syncIssue: "Action à vérifier",
    unavailable: "Indisponible",
    unsavedChanges: "Modifications non enregistrées",
    waitingSync: "En attente de synchronisation",
  },
} as const;

export type MessageKey = keyof (typeof messages)["ar"];

export function translate(locale: Locale, key: MessageKey): string {
  return messages[locale][key];
}
